import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

export default function LinearProgressBar() {
  return (
    <Box sx={{ width: '50%' }}>
      <LinearProgress />
    </Box>
  );
}